module.exports = __webpack_public_path__ + "img/signup-coins.96375b41.png";